export const modifySpots = (dates, spots) => {
    const modifySpots = {};
    dates?.forEach(date => {
        modifySpots[date] = spots[date] || [];
    });

    return modifySpots;
};